import React from 'react';
import { createRoot } from 'react-dom/client';

import { initializeSentry } from '@paragon/client-tools';
import { attemptAutomaticLogInWithStoredToken, initializeDataConnectionsAndLoginTools } from '@paragon/login-tools';

import { startApp } from './actions/startApp';
import MaterialManagerClient from './components/layout/MaterialManagerClient';
import { store } from './store';

initializeSentry();
initializeDataConnectionsAndLoginTools(store);

store.dispatch(attemptAutomaticLogInWithStoredToken()).then((user) => {
  if (user) {
    store.dispatch(startApp);
  }
});

const root = createRoot(document.querySelector('.root')!);
root.render(<MaterialManagerClient reduxStore={store} />);
